import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getAllPlans, startFreeTrial } from "store/actions/subscriptionSlice";
import logo from "../../assets/images/icons/checked.svg";
import classNames from "classnames";
import { showAlert } from "store/reducers/alertReducer";
import { useNavigate } from "react-router-dom";
import ButtonLoader from "components/common/ButtonLoader";
import { CurrencySymbol } from "components/common/Utils";
import { getCompanyInfo } from "store/actions/authSlice";

const PlanPicker = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoading, allPlans } = useSelector((state) => state.Subscriptions);
  const { orgnisationDetails } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getAllPlans());
    dispatch(getCompanyInfo());
  }, [dispatch]);

  const handlePlanClick = (plan) => {
    const authUser = JSON.parse(localStorage.getItem("authUser")) || {};

    const { autoRedirectUrl } = authUser || {};

    // FOR FREE TRIAL
    if (!plan.isCustom && plan.trialPeriodDays > 0) {
      dispatch(startFreeTrial({ planId: plan.id })).then((action) => {
        const { statusCode, success, message, data } = action?.payload || {};
        if (statusCode === 200 && success && data) {
          const { hasSubscriptionEntry } = data || {};
          if (hasSubscriptionEntry) {
            window.location.replace(autoRedirectUrl);
            // navigate('/welcome-message');
          }
        } else {
          dispatch(
            showAlert({
              type: "error",
              text: message,
            })
          );
        }
      });
    } else {
    }
  };

  // useEffect(() => {
  //   if(orgnisationDetails.hasSubscriptionEntry && orgnisationDetails.isCompanyDetailsSaved){
  //     navigate('/dashboards/overview');
  //   }
  // }, [dispatch])

  return (
    <div className="plan_picker_page">
      <div className="container">
        <div className="row">
          {isLoading && <p>{t("Loading plans...")}</p>}

          {!isLoading && allPlans?.length > 0
            ? allPlans.map((plan) => (
                <div
                  className={`col-lg-4 mb-4 ${
                    orgnisationDetails.selectedPlan === plan.name
                      ? "active"
                      : ""
                  }`}
                  key={plan.id}
                >
                  <div
                    className={classNames("plan_picker_card_container", {
                      popular: plan.isPopular,
                      active: plan.name === orgnisationDetails.selectedPlan,
                    })}
                  >
                    <div className="plan_details_top text-center">
                      {plan.isPopular && (
                        <span className="badge badge-popular">
                          {t("Most Popular")}
                        </span>
                      )}

                      <h3 className="plan_type">
                        {i18n.language === "ar" ? plan.nameAr : plan.name}
                      </h3>

                      <h2 className="plan_pricing">
                        {!plan.isCustom && (
                          <CurrencySymbol width="24" height="24" />
                        )}
                        {plan.isCustom
                          ? t("Custom Price")
                          : `${plan.discountedPrice}`}
                        {!plan.isCustom && (
                          <span className="plan_period">
                            /{plan.billingCycle}
                          </span>
                        )}
                      </h2>

                      <p className="plan_description">
                        {i18n.language === "ar"
                          ? plan.descriptionAr || plan.description
                          : plan.description}
                      </p>
                      <div className="plan_benefits_points">
                        <ul>
                          {plan.features.map((feature) => (
                            <li key={feature._id}>
                              <img
                                src={logo}
                                width={24}
                                height={24}
                                alt="Work Space Logo"
                              />
                              <span>
                                {i18n.language === "ar"
                                  ? feature.titleAr
                                  : feature.title}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="plan_picker_bottom">
                      <button
                        onClick={() => handlePlanClick(plan)}
                        className="plan_picker_button  primary_btn w-100 g_center gap-2"
                      >
                        {plan.isCustom
                          ? t("Contact Us")
                          : t("Start Free Trial")}
                        {isLoading && <ButtonLoader />}
                      </button>
                    </div>
                  </div>
                </div>
              ))
            : !isLoading && <p>{t("No plans available")}</p>}
        </div>
      </div>
    </div>
  );
};

export default PlanPicker;
